import { Card, Box } from '@mui/material'
import {
  Content,
  TitleWrapper,
  Title,
  Message,
  Time,
  ErrorWrapper,
  ErrorLabel,
  ErrorText,
} from './ErrorFallbackCard.styles'
import { ErrorFallbackCardProps } from './ErrorFallbackCard.types'

export const ErrorFallbackCard = ({
  title,
  message,
  time,
  errorCodeLabel,
  errorCodeValue,
  errorDescriptionLabel,
  errorDescriptionValue,
}: ErrorFallbackCardProps) => {
  return (
    <Card>
      <TitleWrapper>
        <Title>{title}</Title>
      </TitleWrapper>
      <Content>
        <Message>{message}</Message>
        <Time>{time}</Time>
        <ErrorWrapper>
          <Box>
            <ErrorLabel>{errorCodeLabel}:</ErrorLabel>
            <ErrorText>{errorCodeValue}</ErrorText>
          </Box>
          <ErrorLabel>{errorDescriptionLabel}:</ErrorLabel>
          <Box component="span"> {errorDescriptionValue}</Box>
        </ErrorWrapper>
      </Content>
    </Card>
  )
}
